import type { CashierQueue } from '@creator/sdk/modules/cashier/cashier.model';
import type { GetCashierQueueFilterBy, GetCashierQueueOrderBy } from '@creator/sdk/modules/cashier/cashier.service';
import type { DocumentSnapshot } from '@creator/sdk/modules/db/db.model';
import type { Pagination } from '@creator/sdk/utils/utils';
import creatorSdk from '@src/services/creator-sdk';

export async function loadCashierQueue(
    tokenName: string,
    startAfter: DocumentSnapshot | null,
    limit: number,
    filterBy?: GetCashierQueueFilterBy[],
    orderBy?: GetCashierQueueOrderBy
): Promise<Pagination<CashierQueue>> {
    return creatorSdk.cashierModule.getCashierQueue(tokenName, startAfter, limit, filterBy, orderBy);
}
